var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: 'date-recurrence-input ' + _vm.fieldClass,
    attrs: {
      "id": _vm.fieldId,
      "data-test": _vm.dataTest
    }
  }, [_vm._l(_vm.getChildFields, function (childElement) {
    var _vm$fieldValue;
    return [_vm.showChildField(childElement) ? _c('entity-form-field', {
      key: childElement === null || childElement === void 0 ? void 0 : childElement.field_name,
      attrs: {
        "field-data": childElement,
        "parent-value": (_vm$fieldValue = _vm.fieldValue) === null || _vm$fieldValue === void 0 ? void 0 : _vm$fieldValue[childElement.field_name],
        "bundle": _vm.bundle,
        "entity-type": _vm.entityType,
        "show-label": false
      },
      on: {
        "update-form-data": function (value) {
          return _vm.pickUpdateMethod(value);
        }
      }
    }) : _vm._e()];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }